export default "__VITE_ASSET__BDItHfHh__"